import { createHash } from "crypto"

export interface DocumentMetadata {
	fileId: string
	fileName: string
	totalNumOfPages: number
}

export function DocumentOrderHash(documentsMetadata: DocumentMetadata[]): string {
  const fileIdsJson = JSON.stringify(
    documentsMetadata.map(({ fileId }) => fileId)
  );
  return createHash('md5').update(fileIdsJson).digest('hex');
}